import cedulas from "./Cedulas/Cedulas"
import administracion from "./administracion/administracion"
import notificaciones from "./Notificaciones/Notificaciones"
import consultas from './Consultas/Consultas'
import reportes from './Reportes/Reportes'

const sinoj = {
  cedulas: cedulas,  
  administracion: administracion,
  notificaciones: notificaciones,
  consultas: consultas,
  reportes: reportes
}

export default sinoj



//////////////////
// WEBPACK FOOTER
// ./static/js/api/SINOJ/sistema/sistemaSINOJ.js
// module id = null
// module chunks = 